export enum Experiments {
  PrivateMemberIndicator = 'specs.membersArea.PrivateMemberIndicator',
  ShowRoleLabelToggle = 'specs.profileCardOOI.roleLabelToggle',
  RateFromAppSettings = 'specs.membersArea.rateFromAppSettings',
  TitleForAll = 'specs.profileCardOOI.TitleForAll',
  ShowSuspendedForAdminsOnly = 'specs.profileCardOOI.ShowSuspendedForAdminsOnly',
}
